import { render } from "./NewTerritory.vue?vue&type=template&id=c3789bdc&scoped=true"
import script from "./NewTerritory.vue?vue&type=script&lang=js"
export * from "./NewTerritory.vue?vue&type=script&lang=js"

import "./NewTerritory.vue?vue&type=style&index=0&id=c3789bdc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3789bdc"]])

export default __exports__